<template lang="pug">
    tr

        // ID
        td {{ item.id }}

        // Duration
        td {{ item.duration }}

        // Duration in months'
        td {{ item.duration_in_months}}

        // Discount off
        td(v-if="item.percent_off") {{ `${item.percent_off}%`}}
        td(v-else) {{ `$${item.amount_off/100}`}}

        // Max redemptions
        td {{ item.max_redemptions }}

        // Times redeemed
        td {{ item.times_redeemed }}

        // Redeem by
        td {{ item.redeem_by | FormattedUnixDate }}

        // Valid
        td {{ item.valid ? 'Yes' : 'No' }}


        // Actions
        td.text-xs-right(class="justify-center px-0 actions")

            // Delete business button
            button-component.delete(:action="remove" color="primary" icon="delete")
</template>

<script>
    import VueTypes from 'vue-types';
    import ButtonIcon from '~components/ButtonIcon';
    import Status from '~components/Status';
    import FormattedUnixDate from '~filters/FormattedUnixDate';
    import { mapActions } from 'vuex';

    export default {
        components: {
            ButtonComponent: ButtonIcon,
            StatusComponent: Status
        },
        filters: {
            FormattedUnixDate
        },
        props: {
            item: VueTypes.object.def({})
        },
        methods: {
            ...mapActions('coupons', ['delete', 'getCoupons']),

            /**
             * Delete coupon.
             * @returns {Promise<void>}
             */
            async remove() {
                const resp = await this.delete(this.item.id);

                if (resp) {
                    this.getCoupons();
                }
            }
        }
    };
</script>

<style lang="stylus" scoped>
    .role
        text-transform: capitalize
</style>
